import { render, staticRenderFns } from "./onebox-previewnewtab.vue?vue&type=template&id=0204a553&scoped=true&"
import script from "./onebox-previewnewtab.vue?vue&type=script&lang=js&"
export * from "./onebox-previewnewtab.vue?vue&type=script&lang=js&"
import style0 from "./onebox-previewnewtab.vue?vue&type=style&index=0&id=0204a553&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204a553",
  null
  
)

export default component.exports